import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { RealTimeEvents } from '@app/core/signalr.events';
import { SignalrService } from '@app/core/signalr.service';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { AgentStatusService } from '@projects/shared/src/app/services/agentstatus.service';
import { RealTimeNotificationService } from '@projects/shared/src/app/services/realTimeNotification/real-time-notification.service';

@Component({
  selector: 'app-pre-logout',
  templateUrl: './pre-logout.component.html',
  styleUrls: ['./pre-logout.component.sass'],
})
export class PreLogoutComponent implements OnInit {
  constructor(
    private authService: AuthenticationService,
    private signalRService: SignalrService,
    private realTimeNotificationService: RealTimeNotificationService,
    private agentStatusService: AgentStatusService
  ) {}

  ngOnInit(): void {
    //* No need for this as we are handiling on logout click and froce seperatly
    //this.agentStatusService.statusChangeEvent('LoggedOut', this.agentStatusService.reservedStatus.FriendlyName, '0');
    //this.onLogOutEvent('LoggedOut', this.agentStatusService.reservedStatus.FriendlyName);
    setTimeout(() => {
      this.signalRService.invoke(RealTimeEvents.RemoveConnectionIds, this.authService.authData?.Email);
      if (this.signalRService.isConnected()) {
        this.signalRService.disconnect();
      }
    }, 1500);

    this.realTimeNotificationService.unsubscribeListeners();
    console.log(
      `${new Date().toDateString()} ngOnInit [pre-logout.component.ts] line 685 => this.authService.logout() event called`
    );
    this.authService.logout();
  }

  async onLogOutEvent(selectedStatus: string, reservedStatus: string) {
    //* AgentStatusChange Event Invoke
    if (!this.authService.authData) {
      return;
    }
    let clientId = this.authService.authData.ClientId;
    await this.signalRService.invoke(RealTimeEvents.SendAgentStatusChangeNotification, {
      UserId: this.authService.getUserId(),
      ClientId: clientId,
      Campaigns: this.authService.getAllCampaignCode(),
      Email: this.authService.authData.Email,
      NewStatus: selectedStatus,
      OldStatus: reservedStatus,
      StatusTime: '0',
      Role: this.authService.authData.Role,
    });
  }
}
